var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.333 0h2.334v12.571H7L3.5 16 0 12.571h2.333V0zm7.474 7.189h5.39v-1.26h-3.561L15.103.984V0H9.902v1.259h3.378L9.807 6.2v.989z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.82 14.289L14.345 16H16l-2.566-7.218h-1.878L9 16h1.655l.525-1.711h2.64zm-1.189-3.91l.823 2.632h-1.888c.515-1.656.827-2.693.936-3.113.027.118.07.279.13.482z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/Descending.0be219e222cb1bf2b0f5b066e77146cc.svg";
export { ForwardRef as ReactComponent };